"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LinkButtonIcon = exports.ButtonIcon = exports.LinkButton = exports.Button = exports.ButtonIconShapes = exports.ButtonTypes = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var BootstrapHelper_1 = require("../../BootstrapHelper");
var Icon_1 = require("../Icon");
var enums_1 = require("../../enums");
var react_tippy_1 = require("react-tippy");
var Panel_1 = require("../Panel");
var ButtonTypes;
(function (ButtonTypes) {
    ButtonTypes["PRIMARY"] = "primary";
    ButtonTypes["SECONDARY"] = "secondary";
    ButtonTypes["SUCCESS"] = "success";
    ButtonTypes["DANGER"] = "danger";
    ButtonTypes["WARNING"] = "warning";
    ButtonTypes["INFO"] = "info";
    ButtonTypes["LIGHT"] = "light";
    ButtonTypes["DARK"] = "dark";
    ButtonTypes["OUTLINE_PRIMARY"] = "outline-primary";
    ButtonTypes["OUTLINE_SECONDARY"] = "outline-secondary";
    ButtonTypes["OUTLINE_SUCCESS"] = "outline-success";
    ButtonTypes["OUTLINE_DANGER"] = "outline-danger";
    ButtonTypes["OUTLINE_WARNING"] = "outline-warning";
    ButtonTypes["OUTLINE_INFO"] = "outline-info";
    ButtonTypes["OUTLINE_LIGHT"] = "outline-light";
    ButtonTypes["OUTLINE_DARK"] = "outline-dark";
    ButtonTypes["LINK"] = "link";
    ButtonTypes["LINK_BIG"] = "link-big";
})(ButtonTypes = exports.ButtonTypes || (exports.ButtonTypes = {}));
var ButtonIconShapes;
(function (ButtonIconShapes) {
    ButtonIconShapes["CIRCLE"] = "circle";
    ButtonIconShapes["RECTANGLE"] = "rectangle";
    ButtonIconShapes["NONE"] = "none";
})(ButtonIconShapes = exports.ButtonIconShapes || (exports.ButtonIconShapes = {}));
/**
 * @category UI-components
 * @param props
 */
var Button = function (props) {
    var cls = (0, BootstrapHelper_1.B)()
        .bl("btn")
        .pmod(props.type || ButtonTypes.PRIMARY)
        .pmod(props.size || "md")
        .add(props.isDisabled ? "disabled" : "").bem;
    return ((0, jsx_runtime_1.jsx)("button", __assign({ "data-testid": props["data-testid"], id: props.id || "", title: props.title || "", style: props.style, className: "".concat(cls, " ").concat(props.className || ""), onClick: props.onClick, disabled: props.isDisabled, "data-tourid": props.tourId }, { children: props.children })));
};
exports.Button = Button;
var LinkButton = function (props) {
    var cls = (0, BootstrapHelper_1.B)()
        .bl("btn")
        .pmod(props.type || ButtonTypes.PRIMARY)
        .pmod(props.size || "md")
        .add(props.isDisabled ? "disabled" : "").bem;
    if (props.linkElement) {
        var T = props.linkElement;
        var linkProps = __assign({}, props);
        linkProps.to = linkProps.href;
        delete linkProps.href;
        delete linkProps.linkElement;
        return (0, jsx_runtime_1.jsx)(T, __assign({}, linkProps));
    }
    delete props.linkElement;
    return ((0, jsx_runtime_1.jsx)("a", __assign({ target: props.target, title: props.title || "", className: "".concat(cls, " ").concat(props.className || ""), href: props.href || props.externalUrl || "" }, { children: props.children })));
};
exports.LinkButton = LinkButton;
var ButtonIcon = function (props) {
    var cls = (0, BootstrapHelper_1.B)()
        .bl("btn")
        .pmod("icon")
        .pmod((props.shape && "shape-" + props.shape) || "shape-rectangle").bem;
    return props.children ? ((0, jsx_runtime_1.jsx)(react_tippy_1.Tooltip, __assign({ position: "bottom", html: (0, jsx_runtime_1.jsx)(Panel_1.Panel, __assign({ background: Panel_1.PanelBackgrounds.BG_WHITE, hasShadow: true, hasBorderRadius: true, className: "p-2" }, { children: props.children })) }, { children: (0, jsx_runtime_1.jsx)(Button, __assign({}, props, { className: "".concat(cls, " ").concat(props.className || ""), onClick: props.onClick }, { children: (0, jsx_runtime_1.jsx)(Icon_1.Icon, { symbol: props.symbol, size: props.iconSize || enums_1.UiSizes.MD }) })) }))) : ((0, jsx_runtime_1.jsx)(Button, __assign({}, props, { className: "".concat(cls, " ").concat(props.className || ""), onClick: props.onClick }, { children: (0, jsx_runtime_1.jsx)(Icon_1.Icon, { symbol: props.symbol, size: props.iconSize || enums_1.UiSizes.MD }) })));
};
exports.ButtonIcon = ButtonIcon;
var LinkButtonIcon = function (props) {
    var cls = (0, BootstrapHelper_1.B)()
        .bl("btn")
        .pmod("icon")
        .pmod((props.shape && "shape-" + props.shape) || "shape-rectangle").bem;
    return ((0, jsx_runtime_1.jsx)(LinkButton, __assign({}, props, { className: "".concat(cls, " ").concat(props.className || ""), "data-tourid": props.tourId }, { children: (0, jsx_runtime_1.jsx)(Icon_1.Icon, { symbol: props.symbol, size: props.iconSize || enums_1.UiSizes.MD }) })));
};
exports.LinkButtonIcon = LinkButtonIcon;
